import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';
import { STORAGE_TYPE } from '../../enums/enums';
import { ImageProfil } from '../../models/ImageProfil';

const DEFAULT_IMAGE = 'assets/default-image.png';

@Pipe({
  name: 'imageToUrlAsync',
  pure: true,
})
export class ImageToUrlPipeAsync implements PipeTransform {
  private baseUrl = environment.basePath;

  // Cache uniquement pour les images non internes
  private externalCache = new Map<string, Promise<string>>();

  transform(value: ImageProfil | null | undefined): Promise<string> {
    if (!value || !value.path) {
      return Promise.resolve(DEFAULT_IMAGE);
    }

    if (value.storage === STORAGE_TYPE.INTERNAL) {
      // Pas de délai ni de cache
      return Promise.resolve(`${this.baseUrl}/${value.path}`);
    }

    const cacheKey = `${value.storage}:${value.path}`;

    // Vérifie si le cache contient déjà la promesse
    if (this.externalCache.has(cacheKey)) {
      return this.externalCache.get(cacheKey)!;
    }

    // Sinon, on crée la promesse avec délai de 3 secondes
    const delayedResult = new Promise<string>(resolve => {
      setTimeout(() => resolve(value.path!), 3000);
    });

    this.externalCache.set(cacheKey, delayedResult);

    return delayedResult;
  }
}
